<template>
  <div id="app">

    <router-view ref="routerView" v-on:resolve="pageRes"/>
    
    <router-link to="/" tag="div" class="footer"></router-link>

  </div>
</template>

<script>
export default {
  name: 'App',

  methods: {
    pageRes(res) {
      console.log(res)
    },
  },
}
</script>

<style>
.footer{
  height: 1.2rem;
  background-color: #FFFFFF;
  background-image: url(~@/assets/image/logo-black.png);
  background-size: auto .4rem;
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/App.vue